// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"6594ab68","475":"13dfbabf"}[chunkId] + ".chunk.js";
};